// chatSecurity.js
import DOMPurify from 'dompurify';

export const MESSAGE_LIMITS = {
  MAX_LENGTH: 2000,
  MIN_INTERVAL: 500, // ms between messages
};

export const sanitizeInput = (input) => {
  if (!input) return '';
  // Only trim whitespace, don't remove special characters
  return input.trim().slice(0, MESSAGE_LIMITS.MAX_LENGTH);
};

export const sanitizeContent = (content) => {
  return DOMPurify.sanitize(content, {
      ALLOWED_TAGS: [
          'p', 'br', 'b', 'i', 'em', 'strong', 'a', 'ul', 
          'ol', 'li', 'pre', 'code', 'img', 'h1', 'h2', 'h3'
      ],
      ALLOWED_ATTR: [
          'href', 'target', 'rel', 'class', 'src', 'alt', 
          'width', 'height'
      ],
      // Add URL sanitization for images
      ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|data|file|image):)/i
  });
};;

// Rate limiting helper
export class RateLimiter {
  constructor(maxMessages, timeWindow) {
    this.maxMessages = maxMessages;
    this.timeWindow = timeWindow * 1000; // convert to milliseconds
    this.messageTimestamps = [];
  }

  canSendMessage() {
    const now = Date.now();
    // Remove old timestamps
    this.messageTimestamps = this.messageTimestamps.filter(
      timestamp => now - timestamp < this.timeWindow
    );
    
    // Check if under limit
    return this.messageTimestamps.length < this.maxMessages;
  }

  recordMessage() {
    this.messageTimestamps.push(Date.now());
  }

  getTimeUntilNextAllowed() {
    if (this.canSendMessage()) return 0;
    
    const now = Date.now();
    const oldestTimestamp = this.messageTimestamps[0];
    return oldestTimestamp + this.timeWindow - now;
  }
}